import React from 'react'

export const ResumeExperience = (props) => {
  return (
    <article className="work-exp">
        <h4 className="company">{props.company} - <i>{props.location}</i></h4>
            <div className="work-exp_content">
            <h4>{props.position}</h4> 
            <span>{props.year}</span>
            <div className="resp">
                <h5>Responsibilities:</h5>
                <ul>
                    {props.responsibility.map((responsibility, index) => (
                        <li key={index}>{responsibility}</li>
                    ))}
                </ul>
            </div>
        </div>
    </article>
  )
}
